var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", attrs: { id: "tab-commonHawb" } },
    [
      _c(
        "div",
        { staticClass: "form-card-wrapper" },
        [
          _c(
            "el-card",
            {
              staticClass: "form-card",
              staticStyle: { width: "100%", "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { height: "100%", width: "1465px" },
                  attrs: { "label-width": "90px", "label-position": "left" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "custom", attrs: { label: "MAWB No." } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-content": "center",
                                "align-items": "center"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "206px" },
                                attrs: {
                                  no: "1",
                                  value: _vm.AirExportUtils.mawbNoDispalyFormat(
                                    _vm.job.mbl
                                  ),
                                  disabled: true
                                }
                              }),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t(
                                      "queryJob.BillOfLadingInformationTracking"
                                    ),
                                    placement: "right"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                      cursor: "pointer"
                                    },
                                    attrs: {
                                      src: _vm.img.follow,
                                      tip: _vm.$t(
                                        "queryJob.BillOfLadingInformationTracking"
                                      )
                                    },
                                    on: {
                                      click: _vm.showMBLDetailBtnClickHandler
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        [
                          _c("span", [_vm._v(" HAWB No. ")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.hblNbr2
                              ? "red-border"
                              : "",
                            staticStyle: { width: "206px" },
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "2",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.hblNbr2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "hblNbr2", $$v)
                              },
                              expression: "form.hblNbr2"
                            }
                          }),
                          _vm.viewSource !== "AeTabSubBill"
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: ["button_insurance_toInsure"],
                                      expression:
                                        "['button_insurance_toInsure']"
                                    }
                                  ],
                                  class: !_vm.isEditing
                                    ? "el-button el-button--primary el-button--mini"
                                    : "el-button el-button--primary el-button--mini is-disabled",
                                  staticStyle: {
                                    "min-width": "50px!important",
                                    "margin-left": "15px"
                                  },
                                  attrs: {
                                    id: "Insure",
                                    type: "primary",
                                    no: "Insure"
                                  },
                                  on: {
                                    click: function() {
                                      if (!_vm.isEditing) {
                                        _vm.pm.toInsure()
                                      }
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Insure")) + " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "3",
                                type: "primary",
                                disabled: !_vm.isEditing
                              },
                              on: { click: _vm.showAddressFormatDialog }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.AntiTerroristFormattedAddress"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "4",
                                disabled: !_vm.isEditing,
                                type: "primary"
                              },
                              on: { click: _vm.copyFromOtherBillHandler }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("SeaExport.CopyFromOtherBill")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "5",
                                disabled: !_vm.isEditing,
                                type: "primary"
                              },
                              on: { click: _vm.popUpAddressWindow }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("SeaExport.CodeSearching")) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "6",
                                disabled: !_vm.isEditing,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.copyMblCargoDoc()
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("SeaExport.CopyTheMbl")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "margin-right": "10px" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { label: "Shipper" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    width: "520px"
                                  }
                                },
                                [
                                  _c("cargo-input", {
                                    ref: "shipperCode",
                                    class: _vm.importDifferenceField.shipperCode
                                      ? "red-border"
                                      : "",
                                    staticStyle: { width: "175px" },
                                    attrs: {
                                      disabled: !_vm.isEditing,
                                      no: "7",
                                      "auto-uppercase":
                                        _vm.notUppercaseShipperConsigneNotify
                                    },
                                    model: {
                                      value: _vm.form.shipperCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "shipperCode", $$v)
                                      },
                                      expression: "form.shipperCode"
                                    }
                                  }),
                                  _c("cargo-company-select", {
                                    class: _vm.importDifferenceField.shipperId
                                      ? "red-border"
                                      : "",
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "240px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      no: "8",
                                      "method-params": {
                                        shipper: true,
                                        active: true
                                      },
                                      disabled: !_vm.isEditing,
                                      "default-value": _vm.form.shipperId || "",
                                      fields: ["englishName"],
                                      "tag-name": "englishName",
                                      placeholder: " "
                                    },
                                    on: {
                                      change: function(data) {
                                        _vm.shipperChangeHandler(data)
                                      }
                                    }
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: { no: "9", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.onClear(1)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                  ),
                                  _c("char-count", {
                                    attrs: {
                                      inline: "",
                                      form: _vm.form,
                                      prefix: "shipper"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine1",
                                class: _vm.importDifferenceField.shipperLine1
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "10",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "shipperLine1",
                                      "shipperLine2",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showShipperDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.shipperLine1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperLine1", $$v)
                                  },
                                  expression: "form.shipperLine1"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine2",
                                class: _vm.importDifferenceField.shipperLine2
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "11",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "shipperLine2",
                                      "shipperLine3",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showShipperDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.shipperLine2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperLine2", $$v)
                                  },
                                  expression: "form.shipperLine2"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine3",
                                class: _vm.importDifferenceField.shipperLine3
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "12",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "shipperLine3",
                                      "shipperLine4",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showShipperDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.shipperLine3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperLine3", $$v)
                                  },
                                  expression: "form.shipperLine3"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine4",
                                class: _vm.importDifferenceField.shipperLine4
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "13",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "shipperLine4",
                                      "shipperLine5",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showShipperDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.shipperLine4,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperLine4", $$v)
                                  },
                                  expression: "form.shipperLine4"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine5",
                                class: _vm.importDifferenceField.shipperLine5
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "14",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "shipperLine5",
                                      "shipperLine6",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showShipperDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.shipperLine5,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperLine5", $$v)
                                  },
                                  expression: "form.shipperLine5"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine6",
                                class: _vm.importDifferenceField.shipperLine6
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "15",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showShipperDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.shipperLine6,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperLine6", $$v)
                                  },
                                  expression: "form.shipperLine6"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine7",
                                class: _vm.importDifferenceField.shipperLine7
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "150",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showShipperDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.shipperLine7,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperLine7", $$v)
                                  },
                                  expression: "form.shipperLine7"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { label: "Consignee" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    width: "520px"
                                  }
                                },
                                [
                                  _c("cargo-input", {
                                    ref: "consigneeCode",
                                    class: _vm.importDifferenceField
                                      .consigneeCode
                                      ? "red-border"
                                      : "",
                                    staticStyle: { width: "175px" },
                                    attrs: {
                                      disabled: !_vm.isEditing,
                                      no: "16",
                                      "auto-uppercase":
                                        _vm.notUppercaseShipperConsigneNotify
                                    },
                                    model: {
                                      value: _vm.form.consigneeCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "consigneeCode", $$v)
                                      },
                                      expression: "form.consigneeCode"
                                    }
                                  }),
                                  _c("cargo-company-select", {
                                    ref: "consigneeId",
                                    class: _vm.importDifferenceField.consigneeId
                                      ? "red-border"
                                      : "",
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "240px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      no: "17",
                                      "method-params": {
                                        consignee: true,
                                        active: true
                                      },
                                      "default-value":
                                        _vm.form.consigneeId || "",
                                      disabled: !_vm.isEditing,
                                      fields: ["englishName"],
                                      "tag-name": "englishName",
                                      placeholder: " "
                                    },
                                    on: {
                                      change: function(data) {
                                        _vm.consigneeChangeHandler(data)
                                      }
                                    }
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: { no: "18", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.onClear(2)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                  ),
                                  _c("char-count", {
                                    attrs: {
                                      inline: "",
                                      form: _vm.form,
                                      prefix: "consignee"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine1",
                                class: _vm.importDifferenceField.consigneeLine1
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "19",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "consigneeLine1",
                                      "consigneeLine2",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showConsigneeDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.consigneeLine1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "consigneeLine1", $$v)
                                  },
                                  expression: "form.consigneeLine1"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine2",
                                class: _vm.importDifferenceField.consigneeLine2
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "20",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "consigneeLine2",
                                      "consigneeLine3",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showConsigneeDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.consigneeLine2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "consigneeLine2", $$v)
                                  },
                                  expression: "form.consigneeLine2"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine3",
                                class: _vm.importDifferenceField.consigneeLine3
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "21",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "consigneeLine3",
                                      "consigneeLine4",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showConsigneeDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.consigneeLine3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "consigneeLine3", $$v)
                                  },
                                  expression: "form.consigneeLine3"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine4",
                                class: _vm.importDifferenceField.consigneeLine4
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "22",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "consigneeLine4",
                                      "consigneeLine5",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showConsigneeDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.consigneeLine4,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "consigneeLine4", $$v)
                                  },
                                  expression: "form.consigneeLine4"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine5",
                                class: _vm.importDifferenceField.consigneeLine5
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "23",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "consigneeLine5",
                                      "consigneeLine6",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showConsigneeDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.consigneeLine5,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "consigneeLine5", $$v)
                                  },
                                  expression: "form.consigneeLine5"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine6",
                                class: _vm.importDifferenceField.consigneeLine6
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "24",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showConsigneeDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.consigneeLine6,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "consigneeLine6", $$v)
                                  },
                                  expression: "form.consigneeLine6"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine7",
                                class: _vm.importDifferenceField.consigneeLine7
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "240",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showConsigneeDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.consigneeLine7,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "consigneeLine7", $$v)
                                  },
                                  expression: "form.consigneeLine7"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column"
                              }
                            },
                            [
                              _c("span", [_vm._v("Airport of Departure")]),
                              _c("cargo-input", {
                                class: _vm.importDifferenceField
                                  .airportOfDeparture
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "25",
                                  "auto-uppercase": _vm.isUppercase
                                },
                                model: {
                                  value: _vm.form.airportOfDeparture,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "airportOfDeparture",
                                      $$v
                                    )
                                  },
                                  expression: "form.airportOfDeparture"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { label: "Notify" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    width: "520px"
                                  }
                                },
                                [
                                  _c("cargo-input", {
                                    ref: "notifyCode",
                                    class: _vm.importDifferenceField.notifyCode
                                      ? "red-border"
                                      : "",
                                    staticStyle: { width: "175px" },
                                    attrs: {
                                      disabled: !_vm.isEditing,
                                      no: "26",
                                      "auto-uppercase":
                                        _vm.notUppercaseShipperConsigneNotify
                                    },
                                    model: {
                                      value: _vm.form.notifyCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "notifyCode", $$v)
                                      },
                                      expression: "form.notifyCode"
                                    }
                                  }),
                                  _c("cargo-company-select", {
                                    ref: "notifyId",
                                    class: _vm.importDifferenceField.notifyId
                                      ? "red-border"
                                      : "",
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "240px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      no: "27",
                                      "method-params": {
                                        notify: true,
                                        active: true
                                      },
                                      "default-value": _vm.form.notifyId || "",
                                      disabled: !_vm.isEditing,
                                      fields: ["englishName"],
                                      "tag-name": "englishName",
                                      placeholder: " "
                                    },
                                    on: {
                                      change: function(data) {
                                        _vm.notifyChangeHandler(data)
                                      }
                                    }
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.onClear(3)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                  ),
                                  _c("char-count", {
                                    attrs: {
                                      inline: "",
                                      form: _vm.form,
                                      prefix: "notify"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine1",
                                class: _vm.importDifferenceField.notifyLine1
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "28",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "notifyLine1",
                                      "notifyLine2",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showNotifyDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.notifyLine1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyLine1", $$v)
                                  },
                                  expression: "form.notifyLine1"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine2",
                                class: _vm.importDifferenceField.notifyLine2
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "29",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "notifyLine2",
                                      "notifyLine3",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showNotifyDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.notifyLine2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyLine2", $$v)
                                  },
                                  expression: "form.notifyLine2"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine3",
                                class: _vm.importDifferenceField.notifyLine3
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "30",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "notifyLine3",
                                      "notifyLine4",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showNotifyDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.notifyLine3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyLine3", $$v)
                                  },
                                  expression: "form.notifyLine3"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine4",
                                class: _vm.importDifferenceField.notifyLine4
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "31",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "notifyLine4",
                                      "notifyLine5",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showNotifyDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.notifyLine4,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyLine4", $$v)
                                  },
                                  expression: "form.notifyLine4"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine5",
                                class: _vm.importDifferenceField.notifyLine5
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "32",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.CargoDocUtil.sftAddrChangeWrap(
                                      "notifyLine5",
                                      "notifyLine6",
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showNotifyDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.notifyLine5,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyLine5", $$v)
                                  },
                                  expression: "form.notifyLine5"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine6",
                                class: _vm.importDifferenceField.notifyLine6
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "33",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showNotifyDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.notifyLine6,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyLine6", $$v)
                                  },
                                  expression: "form.notifyLine6"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { class: "label-none custom " },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine7",
                                class: _vm.importDifferenceField.notifyLine7
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: !_vm.isEditing,
                                  no: "330",
                                  maxlength: _vm.maxChars,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showNotifyDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.notifyLine7,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyLine7", $$v)
                                  },
                                  expression: "form.notifyLine7"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column"
                              }
                            },
                            [
                              _c("span", [_vm._v("Issued By")]),
                              _c("cargo-rich-textarea", {
                                class: _vm.importDifferenceField.issuedBy
                                  ? "red-border"
                                  : "",
                                staticStyle: { height: "110px" },
                                attrs: {
                                  no: "34",
                                  disabled: !_vm.isEditing,
                                  "text-chars": 0,
                                  "auto-uppercase": true,
                                  "warning-count": -1
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showAdvanceTextDialog(
                                      "Issued By",
                                      _vm.form.issuedBy,
                                      function(val) {
                                        _vm.form.issuedBy = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.issuedBy,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "issuedBy", $$v)
                                  },
                                  expression: "form.issuedBy"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column"
                              }
                            },
                            [
                              _c("span", [_vm._v("Accounting Information")]),
                              _c("cargo-rich-textarea", {
                                class: _vm.importDifferenceField.accountingInfo
                                  ? "red-border"
                                  : "",
                                staticStyle: { height: "110px" },
                                attrs: {
                                  no: "35",
                                  disabled: !_vm.isEditing,
                                  "auto-uppercase": true,
                                  "text-chars": 0,
                                  "warning-count": -1
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showAdvanceTextDialog(
                                      "Accounting Information",
                                      _vm.form.accountingInfo,
                                      function(val) {
                                        _vm.form.accountingInfo = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.accountingInfo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "accountingInfo", $$v)
                                  },
                                  expression: "form.accountingInfo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "margin-top": "39px"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "margin-right": "2px"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Freight Term")]),
                                  _c("cargo-input", {
                                    staticStyle: { width: "190px" },
                                    attrs: {
                                      no: "36",
                                      "auto-uppercase": _vm.isUppercase,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.freightTerm,
                                      callback: function($$v) {
                                        _vm.freightTerm = $$v
                                      },
                                      expression: "freightTerm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.PiecesType2"))
                                    )
                                  ]),
                                  _c("el-input-number", {
                                    class: _vm.importDifferenceField
                                      .insideQuantity
                                      ? "red-border"
                                      : "",
                                    staticStyle: {
                                      width: "130px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      no: "37",
                                      value:
                                        _vm.form.insideQuantity || undefined,
                                      "controls-position": "right",
                                      controls: false,
                                      min: 0,
                                      max: 999999999999,
                                      disabled: !_vm.isEditing
                                    },
                                    on: {
                                      input: function(val) {
                                        _vm.form.insideQuantity = val
                                      }
                                    }
                                  }),
                                  _c("cargo-input", {
                                    class: _vm.importDifferenceField
                                      .insidePacking
                                      ? "red-border"
                                      : "",
                                    staticStyle: { width: "115px" },
                                    attrs: {
                                      disabled: !_vm.isEditing,
                                      no: "38",
                                      "auto-uppercase": _vm.isUppercase
                                    },
                                    model: {
                                      value: _vm.form.insidePacking,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "insidePacking", $$v)
                                      },
                                      expression: "form.insidePacking"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "300px",
                            "margin-left": "10px",
                            "padding-top": "5px"
                          }
                        },
                        [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c("span", [_vm._v("Operation Requirements")]),
                            _vm.airPortRequirementFileList &&
                            _vm.airPortRequirementFileList.length > 0
                              ? _c(
                                  "a",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "text-decoration": "underline",
                                      color: "#0A0AFF"
                                    },
                                    attrs: { no: "airPortRequirementText" },
                                    on: { click: _vm.airPortRequirementClick }
                                  },
                                  [_vm._v(_vm._s(_vm.airPortRequirementText))]
                                )
                              : _vm._e()
                          ]),
                          _c("el-input", {
                            staticStyle: { height: "110px", width: "300px" },
                            attrs: {
                              no: "39",
                              type: "textarea",
                              rows: 6,
                              disabled: true
                            },
                            model: {
                              value:
                                _vm.airPortRequirement.operationRequirements,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.airPortRequirement,
                                  "operationRequirements",
                                  $$v
                                )
                              },
                              expression:
                                "airPortRequirement.operationRequirements"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("To")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.podTo
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "40",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.podTo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "podTo", $$v)
                              },
                              expression: "form.podTo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            width: "300px",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("By First Carrier")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.carrierBy
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "41",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.carrierBy,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "carrierBy", $$v)
                              },
                              expression: "form.carrierBy"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("To")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.podTo1
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "42",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.podTo1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "podTo1", $$v)
                              },
                              expression: "form.podTo1"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("By")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.carrierBy1
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "43",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.carrierBy1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "carrierBy1", $$v)
                              },
                              expression: "form.carrierBy1"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("To")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.podTo2
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "44",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.podTo2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "podTo2", $$v)
                              },
                              expression: "form.podTo2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("By")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.carrierBy2
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "45",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.carrierBy2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "carrierBy2", $$v)
                              },
                              expression: "form.carrierBy2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("Currency")]),
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.currency
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "46",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              disabled: !_vm.isEditing,
                              filterable: "",
                              clearable: false,
                              "static-options": _vm.currencyList,
                              "default-value": _vm.form.currency
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.currencyChangeHandler(p.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            width: "300px",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("WT/VAL")]),
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.wtVal
                                ? "red-border"
                                : "",
                              attrs: { disabled: !_vm.isEditing, no: "47" },
                              on: {
                                change: function($event) {
                                  return _vm.cpChangeHandler("wtVal")
                                }
                              },
                              model: {
                                value: _vm.form.wtVal,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "wtVal", $$v)
                                },
                                expression: "form.wtVal"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "PP", value: "PP" }
                              }),
                              _c("el-option", {
                                attrs: { label: "CC", value: "CC" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            width: "300px",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("Other")]),
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.other
                                ? "red-border"
                                : "",
                              attrs: { disabled: !_vm.isEditing, no: "48" },
                              on: {
                                change: function($event) {
                                  return _vm.cpChangeHandler("other")
                                }
                              },
                              model: {
                                value: _vm.form.other,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "other", $$v)
                                },
                                expression: "form.other"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "PP", value: "PP" }
                              }),
                              _c("el-option", {
                                attrs: { label: "CC", value: "CC" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            width: "300px",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("D.V.Carrier")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.carriageDv
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "49",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.carriageDv,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "carriageDv", $$v)
                              },
                              expression: "form.carriageDv"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            width: "300px",
                            "margin-right": "2px"
                          }
                        },
                        [
                          _c("span", [_vm._v("D.V. for Customs")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.dvForCustoms
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "50",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.dvForCustoms,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dvForCustoms", $$v)
                              },
                              expression: "form.dvForCustoms"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "65%",
                        display: "flex",
                        "justify-content": "flex-start"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            flex: "1",
                            "margin-right": "10px"
                          }
                        },
                        [
                          _c("span", [_vm._v("Airport of Destination")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField
                              .airportOfDestination
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "51",
                              "filter-chars": false,
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.airportOfDestination,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "airportOfDestination", $$v)
                              },
                              expression: "form.airportOfDestination"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-right": "10px"
                          }
                        },
                        [
                          _c("span", [_vm._v("Flight/Date")]),
                          _c("el-date-picker", {
                            attrs: {
                              no: "52",
                              disabled: true,
                              clearable: "",
                              type: "datetime",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.job.etd,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "etd", $$v)
                              },
                              expression: "job.etd"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-right": "10px"
                          }
                        },
                        [
                          _c("span", [_vm._v("Amount of insurance")]),
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.insuredAmount
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.isEditing,
                              no: "53",
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.form.insuredAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "insuredAmount", $$v)
                              },
                              expression: "form.insuredAmount"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column"
                        }
                      },
                      [
                        _c("span", [_vm._v("Handling Info")]),
                        _c("cargo-rich-textarea", {
                          class: _vm.importDifferenceField.handingInfo
                            ? "red-border"
                            : "",
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "54",
                            disabled: !_vm.isEditing,
                            "text-chars": 0,
                            "auto-uppercase": true,
                            "warning-count": -1
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showAdvanceTextDialog(
                                "Handling Information",
                                _vm.form.handingInfo,
                                function(val) {
                                  _vm.form.handingInfo = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.handingInfo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "handingInfo", $$v)
                            },
                            expression: "form.handingInfo"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("hawb-part1", {
                    ref: "part1",
                    staticStyle: { width: "100%" },
                    attrs: {
                      "cargo-doc": _vm.form,
                      job: _vm.job,
                      action: _vm.action,
                      "is-uppercase-by-config": _vm.isUppercaseByConfig
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: !_vm.isEditing,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditing,
                      expression: "isEditing"
                    }
                  ],
                  attrs: { no: "55", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "56" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.billAddressDialog.job,
          params: _vm.billAddressDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("address-format-dialog", {
        attrs: {
          visible: _vm.addressFormatDialog.visible,
          job: _vm.addressFormatDialog.job,
          params: _vm.addressFormatDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.addressFormatDialog, "visible", $event)
          }
        }
      }),
      _c("copy-from-other-bill-dialog", {
        attrs: {
          "doc-type": _vm.copyFromOtherBillDialog.docType,
          visible: _vm.copyFromOtherBillDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyFromOtherBillDialog, "visible", $event)
          },
          selected: _vm.transcribeEnterHandler
        }
      }),
      _c("operation-requirement-dialog", {
        attrs: {
          files: _vm.operationRequirementDialog.files,
          visible: _vm.operationRequirementDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.operationRequirementDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }